(() => {
  if (window.pacificRevealLoaded) return;
  window.pacificRevealLoaded = true;
  document.addEventListener('click', event => {
    const link = event.target.closest('.pv2 a[href^="#"]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'start'});
    history.pushState(null,'',link.hash);
  });
  const init = async () => {
    if (window.Shopify?.designMode || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    await document.fonts.ready;
    // Keep the opening hero calm and immediately readable. Editorial content
    // below it retains the one-time line reveal as it enters the viewport.
    const headings = [...document.querySelectorAll('.pv2:not(.pv2--hero) h2,.pv2:not(.pv2--hero) h3')];
    const original = new Map(headings.map(el => [el, el.innerHTML]));
    const revealed = new WeakSet();
    const observer = new IntersectionObserver(entries => {
      entries.forEach(({target,isIntersecting}) => {
        if (!isIntersecting) return;
        target.classList.add('pacific-revealed');
        revealed.add(target);
        observer.unobserve(target);
      });
    }, {threshold:0,rootMargin:'0px 0px -8% 0px'});
    const split = heading => {
      heading.innerHTML = original.get(heading);
      // Measure actual wrapped lines while preserving the italic second line.
      const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
      const nodes=[];
      while(walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(node => {
        const frag=document.createDocumentFragment();
        node.textContent.split(/(\s+)/).forEach(word => {
          if (!word.trim()) frag.append(document.createTextNode(word));
          else {const span=document.createElement('span');span.className='pacific-word';span.textContent=word;frag.append(span);}
        });
        node.replaceWith(frag);
      });
      const groups=[];
      heading.querySelectorAll('.pacific-word').forEach(word => {
        const top=word.getBoundingClientRect().top;
        let group=groups[groups.length-1];
        if (!group || Math.abs(group.top-top)>5) {group={top,words:[]};groups.push(group);}
        group.words.push({text:word.textContent,italic:!!word.closest('em')});
      });
      heading.textContent='';
      groups.forEach((group,index) => {
        const mask=document.createElement('span');mask.className='pacific-line-mask';
        const line=document.createElement('span');line.className='pacific-line';line.style.setProperty('--line-delay',`${index*110}ms`);
        if(group.words.every(w=>w.italic))mask.classList.add('pacific-line-italic');
        group.words.forEach((word,i)=>{if(i)line.append(document.createTextNode(' ')); const span=document.createElement(word.italic?'em':'span');span.textContent=word.text;line.append(span);});
        mask.append(line);heading.append(mask);
      });
      heading.classList.add('pacific-heading-reveal');
      if(revealed.has(heading)) heading.classList.add('pacific-revealed');
      else observer.observe(heading);
    };
    headings.forEach(split);
    // Give every editorial section the same reveal rhythm: heading, copy, media.
    const supporting = document.querySelectorAll([
      '.pv2 .rte',
      '.pv2-story-image',
      '.pv2-story-detail',
      '.pv2-tide-image',
      '.pv2-craft-grid figure',
      '.pv2-stones-intro figure',
      '.pv2-stone-visual',
      '.pv2-ending-image'
    ].join(','));
    supporting.forEach(el=>{el.classList.add('pacific-support-reveal');observer.observe(el);});
    let width=innerWidth,timer;
    addEventListener('resize',()=>{if(Math.abs(width-innerWidth)<10)return;width=innerWidth;clearTimeout(timer);timer=setTimeout(()=>headings.forEach(split),180);},{passive:true});
    // Reveal focused links immediately and respect a changed motion preference.
    document.addEventListener('focusin',e=>e.target.closest('.pacific-support-reveal')?.classList.add('pacific-revealed'));
    matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change',e=>{if(e.matches)document.querySelectorAll('.pacific-heading-reveal,.pacific-support-reveal').forEach(el=>el.classList.add('pacific-revealed'));});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
